import { default as ResponseStatusIcon } from '../../_internal/components/ResponseStatusIcon';
export default ResponseStatusIcon;